/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionNotificationWebHookForStandardType extends models.ScheduleExecutionNotificationWebhook {
    constructor() {
        super();
        this.setDiscriminator("ScheduleExecutionNotificationWebHookForStandardType");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionNotificationWebHookForStandardType.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionNotificationWebHookForStandardType>): ScheduleExecutionNotificationWebHookForStandardType {
        let obj = Object.assign(new ScheduleExecutionNotificationWebHookForStandardType(), model);
        ScheduleExecutionNotificationWebHookForStandardType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionNotificationWebHookForStandardType>): ScheduleExecutionNotificationWebHookForStandardType {
        if (!model) return null;
        return ScheduleExecutionNotificationWebHookForStandardType.newInstance(<ScheduleExecutionNotificationWebHookForStandardType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionNotificationWebHookForStandardType) {
        if (!obj) return;

        models.ScheduleExecutionNotificationWebHookForStandardType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionNotificationWebHookForStandardType): boolean {
        if (models.ScheduleExecutionNotificationWebhook.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleExecutionNotificationWebHookForStandardType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
